import { useFormContext } from "react-hook-form";

import { FormValues } from "../new-employee-form";

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form/form";
import { HelperButton } from "@/components/ui/helper-button/helper-button";
import { Input } from "@/components/ui/input/input";

interface NewEmployeeSalaryProps {
  isPending: boolean;
}

// ? TAB Salary
// ! grossSalary: number,
// ? TAB Salary

export const NewEmployeeSalary = ({ isPending }: NewEmployeeSalaryProps) => {
  const form = useFormContext<FormValues>();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
      <FormField
        control={form.control}
        name="grossSalary"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-1">
              Gross Salary
              <HelperButton>
                <p>Gross salary of the employee</p>
              </HelperButton>
            </FormLabel>
            <FormControl>
              <Input type="number" {...field} disabled={isPending} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="travellingExpenses"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-1">
              Travelling Expenses
              <HelperButton>
                <p>Travelling Expenses</p>
              </HelperButton>
            </FormLabel>
            <FormControl>
              <Input type="number" {...field} disabled={isPending} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="otherExpenses"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-1">
              Other Expenses
              <HelperButton>
                <p>Other Expenses</p>
              </HelperButton>
            </FormLabel>
            <FormControl>
              <Input type="number" {...field} disabled={isPending} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="paidAmount"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-1">
              Paid Amount
            </FormLabel>
            <FormControl>
              <Input type="number" {...field} disabled={isPending} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
